export default function ControllerState (state = {
    controller: { search_string: '', list:{}, details:{}, validation:{}, options:{},filter:{}},
    controller_config: {list: {}, details: {}, validation: {}, options: {}},
    fw_update: {}, cards_sync:{},
    new_controller: {}}, action) {
    switch(action.type) {
        case 'CONTROLLER_UPDATE_SEARCH_STRING':
            state.controller.search_string = action.value;
            return { ...state };
        case "CONTROLLER_UPDATE_FILTER_STRING":
            state.controller.filter = action.value;
            return { ...state };
        case 'CONTROLLER_SEARCH':
            state.controller.list = action.data.list;
            return { ...state };
        case 'CONTROLLER_OPTIONS':
            state.controller.options = action.data.options;
            return { ...state };
        case 'CONTROLLER_DETAILS':
            state.controller.details = action.data.record;
            return { ...state };
        case 'CONTROLLER_UPDATE_FORM':
            state.controller.details[action.field] = action.value;
            if (state.controller.validation[action.field]) {
                state.controller.validation[action.field] = {};
            }
            return { ...state };
        case 'CONTROLLER_VALIDATION_ERROR':
            state.controller.validation = action.data;
            return { ...state };
        case 'CONTROLLER_SELECTED':
            state.controller.selected = action.value;
            state.controller.details = {};
            state.controller.validation = {};
            return { ...state };
        case 'CONTROLLER_DESELECTED':
        case 'CONTROLLER_UPDATED':
        case 'CONTROLLER_INSERTED':
        case 'CONTROLLER_DELETED':
            state.controller.selected = null;
            state.controller.details = {};
            state.controller.validation = {};
            return { ...state };
        case 'CONTROLLER_INSERT_ERROR':
        case 'CONTROLLER_UPDATE_ERROR':
            state.controller = {};
            return { ...state };
        case 'NEW_CONTROLLER_SELECTED':
            state.new_controller.selected = action.value;
            state.controller.details = action.details;
            return { ...state };
        case 'NEW_CONTROLLER_DESELECTED':
            state.new_controller.selected = null;
            state.controller.details = {};
            return { ...state };
        //controller congigh
        case 'CONTROLLER_CONFIG_SELECTED':
            state.controller_config.selected = action.value;
            return { ...state };
        case 'CONTROLLER_CONFIG_DETAILS':
            state.controller_config.details = action.data.details;
            return { ...state };
        case 'CONTROLLER_CONFIG_UPDATE_FORM':
            state.controller_config.details['controller_id'] = state.controller.selected;
            state.controller_config.details[action.field] = action.value;
            if (state.controller_config.validation[action.field]) {
                state.controller_config.validation[action.field] = {};
            }
            return { ...state };
        case 'CONTROLLER_CONFIG_DESELECTED':
            state.controller_config.selected = null;
            state.controller_config.validation = {};
            state.controller_config.details = {};
            return { ...state };
        case 'CONTROLLER_CONFIG_VALIDATION_ERROR':
            state.controller_config.validation = action.data;
            return { ...state };
        case 'FW_UPDATE':
            if (action.data.ap === 2) {
                if (state.fw_update[action.data.mac]) delete state.fw_update[action.data.mac];
            } else {
                if (!state.fw_update[action.data.mac]) state.fw_update[action.data.mac] = {};
                state.fw_update[action.data.mac].mac = action.data.mac;
                state.fw_update[action.data.mac].ap = action.data.ap;
                state.fw_update[action.data.mac].end = action.data.end;
                state.fw_update[action.data.mac].fsize = action.data.fsize;
            }    
            return { ...state };
        case 'CARDS_SYNC':
            if (action.data.ap === 2) {
                if (state.cards_sync[action.data.mac]) delete state.cards_sync[action.data.mac];
            } else {
                if (!state.cards_sync[action.data.mac]) state.cards_sync[action.data.mac] = {};
                state.cards_sync[action.data.mac].mac = action.data.mac;
                state.cards_sync[action.data.mac].ap = action.data.ap;
                state.cards_sync[action.data.mac].end = action.data.end;
                state.cards_sync[action.data.mac].qty = action.data.qty;
            }    
            return { ...state };
        default:
            break;
    }
    return state;
}

